import { GetPBTermsInterface } from "@type/payBill.types"
import { GetPayGroupsInterface } from "@type/payGroup.types"
import { createContext } from "react"

export interface TermContextProps {
	handleRow: (e: GetPayGroupsInterface | null) => void
	pbTerm: GetPBTermsInterface | null
	isPbTermLoading: boolean
	pbTerms: GetPBTermsInterface[]
}

const TermContext = createContext<TermContextProps | null>(null)

export default TermContext
